// Helper function to get favicon URL
export const getFaviconUrl = (url) => {
  try {
    const domain = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=16`;
  } catch {
    // If URL parsing fails, try using the raw URL
    return `https://www.google.com/s2/favicons?domain=${url}&sz=16`;
  }
};

// This is a direct approach that bypasses React's reconciliation for guaranteed highlighting
export const createHighlightedHTML = (text, searchQuery, isActive) => {
  if (!searchQuery?.trim() || !text) {
    console.log('Cannot highlight: empty query or text');
    return text;
  }
  
  // Escape HTML special characters first
  const escapeHTML = (str) => {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  // Escape the query for regex special characters
  const escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const escapedText = escapeHTML(text);
  const escapedQuery = escapeRegExp(searchQuery);
  
  // Create regex for exact matching
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  
  // Test if any matches exist
  if (!regex.test(text)) {
    console.log('No matches found for:', searchQuery);
    return escapedText;
  }
  
  // Define the highlight style
  const highlightClass = isActive 
    ? 'background-color: #facc15; color: black; padding: 1px 2px; border-radius: 2px; font-weight: bold; box-shadow: 0 0 0 1px #ca8a04;' 
    : 'background-color: #fef08a; color: black; padding: 1px 2px; border-radius: 2px;';
  
  // Use a custom replace function that preserves the formatting
  const replacedHTML = escapedText.replace(new RegExp(`(${escapedQuery})`, 'gi'), (match) => {
    return `<mark style="${highlightClass}">${escapeHTML(match)}</mark>`;
  });
  
  console.log('Successfully highlighted matches for term:', searchQuery);
  return replacedHTML;
};

// Utility functions for working with data-start/data-end attributes
export const getContentByRange = (startChar, endChar, fullText) => {
  return fullText.slice(startChar, endChar + 1);
};

export const findElementsByCharRange = (startChar, endChar, containerRef) => {
  if (!containerRef.current) return [];
  
  const elements = containerRef.current.querySelectorAll('[data-start][data-end]');
  return Array.from(elements).filter(el => {
    const elStart = parseInt(el.getAttribute('data-start'));
    const elEnd = parseInt(el.getAttribute('data-end'));
    return (elStart >= startChar && elStart <= endChar) || 
           (elEnd >= startChar && elEnd <= endChar) ||
           (elStart <= startChar && elEnd >= endChar);
  });
};

// Improved proxy URL function to better handle S3 URLs
export const getProxiedImageUrl = (s3Url) => {
  if (!s3Url) return null;
  
  // If it's already not an S3 URL, just return it as is
  if (!s3Url.includes('amazonaws.com')) {
    return s3Url;
  }
  
  // Extract file key from the S3 URL (everything after the bucket name)
  const urlParts = s3Url.split('/');
  const fileKey = urlParts.slice(3).join('/');
  
  // Return URL that will be handled by our backend proxy endpoint
  return `${process.env.REACT_APP_API_URL}/brand/image-proxy?key=${encodeURIComponent(fileKey)}`;
};

// Process quotes to handle smart quotes
export const processQuotes = (text) => {
  if (!text) return '';
  
  // Replace smart quotes with regular quotes
  return text
    .replace(/"/g, '"')
    .replace(/"/g, '"')
    .replace(/'/g, "'")
    .replace(/'/g, "'");
}; 